export default __webpack_public_path__ + "static/media/audio-icon.ef36aa9b.svg";